import { create } from "zustand"

export enum SecondaryBarContent {
  Notifications = "Notifications",
}

interface SecondaryBar {
  open: boolean
  content: SecondaryBarContent | null
}

type FilterStore = {
  secondaryBar: SecondaryBar
  setSecondaryBar: (data: SecondaryBar) => void
}

const useSidebarStore = create<FilterStore>((set, get) => ({
  secondaryBar: {
    open: false,
    content: null,
  },
  setSecondaryBar: secondaryBar => {
    set(() => ({ secondaryBar }))
  },
}))

export const useSidebar = () => {
  const { secondaryBar, setSecondaryBar } = useSidebarStore()

  const closeSecondaryBar = () => {
    document.body.style.overflow = "auto"
    setSecondaryBar({
      open: false,
      content: null,
    })
  }

  const openSecondaryBar = ({ content }: { content: SecondaryBarContent }) => {
    document.body.style.overflow = "hidden"
    setSecondaryBar({
      open: true,
      content,
    })
  }

  return {
    openSecondaryBar,
    secondaryBar,
    closeSecondaryBar,
  }
}
